const commonColumnStyle1 = 'max-width: 200px; min-width: 200px';

export const STOCK_DATA_COLUMNS_FULL = [
    {
        field: 'codeId129',
        header: 'Stock Symbol',
        style: commonColumnStyle1,
        sortable: true,
        frozen: true,
        body: 'link'
    },
    {
        field: 'companyNameId046',
        header: 'Name',
        style: commonColumnStyle1,
        sortable: true
    },
    {
        field: 'sharePriceId123',
        header: 'Share Price',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'currentDividendYieldId050',
        header: 'Current Div Yld',
        style: commonColumnStyle1,
        sortable: true,
        body: 'dividend'
    },
    {
        field: 'siCriteriaYear20Id128',
        header: 'SI Criteria out of 10 (20yr Data)',
        style: commonColumnStyle1,
        sortable: true
    },
    {
        field: 'siCriteriaYear15Id127',
        header: 'SI Criteria out of 10 (15yr Data)',
        style: commonColumnStyle1,
        sortable: true
    },
    {
        field: 'siCriteriaYear10Id126',
        header: 'SI Criteria out of 10 (10yr Data)',
        style: commonColumnStyle1,
        sortable: true
    },
    {
        field: 'siCriteriaYear5Id125',
        header: 'SI Criteria out of 10 (5yr Data)',
        style: commonColumnStyle1,
        sortable: true
    },
    {
        field: 'averageEpsGrowthYear20Id018',
        header: 'R5a – Avg EPS Growth 20yr',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'averageEpsGrowthYear15Id017',
        header: 'R5a – Avg EPS Growth 15yr',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'averageEpsGrowthYear10Id016',
        header: 'R5a – Avg EPS Growth 10yr',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    }, {
        field: 'averageEpsGrowthYear5Id015',
        header: 'R5a – Avg EPS Growth 5yr',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'epsIncreasesYear20Id097',
        header: 'R5b – EPS Increases in 20yrs',
        style: commonColumnStyle1,
        sortable: true
    },
    {
        field: 'epsIncreasesYear15Id096',
        header: 'R5b – EPS Increases in 15yrs',
        style: commonColumnStyle1,
        sortable: true
    },
    {
        field: 'epsIncreasesYear10Id095',
        header: 'R5b – EPS Increases in 10yrs',
        style: commonColumnStyle1,
        sortable: true
    },
    {
        field: 'epsIncreasesYear5Id094',
        header: 'R5b – EPS Increases in 5yrs',
        style: commonColumnStyle1,
        sortable: true
    },
    {
        field: 'adgYear20Id009',
        header: 'R6 – Avg Div Growth 20yr',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'adgYear15Id008',
        header: 'R6 – Avg Div Growth 15yr',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'adgYear10Id007',
        header: 'R6 – Avg Div Growth 10yr',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'adgYear5Id006',
        header: 'R6 – Avg Div Growth 5yr',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'payoutRatioId107',
        header: 'R7 – Payout Ratio',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'longtermDebtEquityRatioId084',
        header: 'R8 - LT Debt/Equity',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'afdPreviousId005',
        header: 'R9 - Fwd Dividend vs Prev Year',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'shareBuybackId122',
        header: 'R10 – Share Buyback?',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-buyback'
    },
    {
        field: 'peRatioId104',
        header: 'R11a – P/E Ratio TTM',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'undervaluedVsOvervaluedStatusYear20Id135',
        header: 'R11b – Under/Over Valued Using 20yr Data',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-overvalue'
    },
    {
        field: 'undervaluedVsOvervaluedStatusYear15Id134',
        header: 'R11b – Under/Over Valued Using 15yr Data',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-overvalue'
    },
    {
        field: 'undervaluedVsOvervaluedStatusYear10Id133',
        header: 'R11b – Under/Over Valued Using 10yr Data',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-overvalue'
    },
    {
        field: 'undervaluedVsOvervaluedStatusYear5Id132',
        header: 'R11b – Under/Over Valued Using 5yr Data',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-overvalue'
    },
    {
        field: 'pbRatioId102',
        header: 'R11c – P/B Ratio',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'yearsDividendIncreasesId047',
        header: 'Consecutive Yrs Div Increases',
        style: commonColumnStyle1,
        sortable: true
    },
    {
        field: 'hspWeek52Id001',
        header: '52wk High',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'lspWeek52Id002',
        header: '52wk Low',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'altmanZscoreId003',
        header: 'Altman Z-Score',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'afdId004',
        header: 'Annual Fwd Dividend',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'adyYear5Id010',
        header: 'Avg Div Yld 5yr',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'adyYear10Id011',
        header: 'Avg Div Yld 10yr',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'adyYear15Id012',
        header: 'Avg Div Yld 15yr',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'adyYear20Id013',
        header: 'Avg Div Yld 20yr',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'averageEpsYear3Id014',
        header: 'Avg 3yr EPS',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'averageHdyYear5Id019',
        header: 'Avg High Div Yld 5yr',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'averageHdyYear10Id020',
        header: 'Avg High Div Yld 10yr',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'averageHdyYear15Id021',
        header: 'Avg High Div Yld 15yr',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'averageHdyYear20Id022',
        header: 'Avg High Div Yld 20yr',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'averageHighPeRatioYear5Id023',
        header: 'Avg High P/E 5yr',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'averageHighPeRatioYear10Id024',
        header: 'Avg High P/E 10yr',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'averageHighPeRatioYear15Id025',
        header: 'Avg High P/E 15yr',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'averageHighPeRatioYear20Id026',
        header: 'Avg High P/E 20yr',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'averageLdyYear5Id027',
        header: 'Avg Low Div Yld 5yr',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'averageLdyYear10Id028',
        header: 'Avg Low Div Yld 10yr',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'averageLdyYear15Id029',
        header: 'Avg Low Div Yld 15yr',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'averageLdyYear20Id030',
        header: 'Avg Low Div Yld 20yr',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'averageLowPeRatioYear5Id031',
        header: 'Avg Low P/E 5yr',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'averageLowPeRatioYear10Id032',
        header: 'Avg Low P/E 10yr',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'averageLowPeRatioYear15Id033',
        header: 'Avg Low P/E 15yr',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'averageLowPeRatioYear20Id034',
        header: 'Avg Low P/E 20yr',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'averagePeRatioYear5Id035',
        header: 'Avg P/E 5yr',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'averagePeRatioYear10Id036',
        header: 'Avg P/E 10yr',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'averagePeRatioYear15Id037',
        header: 'Avg P/E 15yr',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'averagePeRatioYear20Id038',
        header: 'Avg P/E 20yr',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'bookValuePerShareId039',
        header: 'Bk Value/Share',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'cashFlowPerShareId040',
        header: 'Cashflow/Share',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'companyAddressCityId041',
        header: 'City',
        style: commonColumnStyle1,
        sortable: true
    },
    {
        field: 'companyAddressCountryId042',
        header: 'Country',
        style: commonColumnStyle1,
        sortable: true
    },
    {
        field: 'companyAddressStateId043',
        header: 'State/Prov',
        style: commonColumnStyle1,
        sortable: true
    },
    {
        field: 'companyAddressId044',
        header: 'Address',
        style: commonColumnStyle1,
        sortable: true
    },
    {
        field: 'companyDescriptionId045',
        header: 'Description',
        style: commonColumnStyle1,
        sortable: true
    },
    {
        field: 'yearsEpsIncreasesId048',
        header: 'Consecutive Yrs EPS Increases',
        style: commonColumnStyle1,
        sortable: true
    },
    {
        field: 'currentAssetsId049',
        header: 'Current Assets',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'currentLiabilitiesId051',
        header: 'Current Debt',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'currentRatioId052',
        header: 'Current Ratio',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'diffDyCurrentVsAverageYear5Id053',
        header: 'Diff Between Current Div Yld & Avg Div Yld 5yrs',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'diffDyCurrentVsAverageYear10Id054',
        header: 'Diff Between Current Div Yld & Avg Div Yld 10yrs',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'diffDyCurrentVsAverageYear15Id055',
        header: 'Diff Between Current Div Yld & Avg Div Yld 15yrs',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'diffDyCurrentVsAverageYear20Id056',
        header: 'Diff Between Current Div Yld & Avg Div Yld 20yrs',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'diffPeCurrentVsAverageYear5Id057',
        header: 'Diff Between Current P/E & Avg P/E 5yrs',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'diffPeCurrentVsAverageYear10Id058',
        header: 'Diff Between Current P/E & Avg P/E 10yrs',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'diffPeCurrentVsAverageYear15Id059',
        header: 'Diff Between Current P/E & Avg P/E 15yrs',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'diffPeCurrentVsAverageYear20Id060',
        header: 'Diff Between Current P/E & Avg P/E 20yrs',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'dcfId061',
        header: 'DCF',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'dividendCurrencyId062',
        header: 'Div Currency',
        style: commonColumnStyle1,
        sortable: true
    },
    {
        field: 'dividendFrequencyId063',
        header: 'Div Frequency',
        style: commonColumnStyle1,
        sortable: true
    },
    {
        field: 'dgPlusDyYear5Id064',
        header: 'Div Gr (5yr) + Curr Div Yld',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'dgPlusDyYear10Id065',
        header: 'Div Gr (10yr) + Curr Div Yld',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'dgPlusDyYear15Id066',
        header: 'Div Gr (15yr) + Curr Div Yld',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'dgPlusDyYear20Id067',
        header: 'Div Gr (20yr) + Curr Div Yld',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'dividendPaymentDateId068',
        header: 'Div Payment Date',
        style: commonColumnStyle1,
        sortable: true
    },
    {
        field: 'dividendRecordDateId069',
        header: 'Div Record Date',
        style: commonColumnStyle1,
        sortable: true
    },
    {
        field: 'dividendPaidId070',
        header: 'Divs Paid Since',
        style: commonColumnStyle1,
        sortable: true
    },
    {
        field: 'epsTtmId071',
        header: 'EPS (TTM)',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'esgScoreId072',
        header: 'ESG Score',
        style: commonColumnStyle1,
        sortable: true
    },
    {
        field: 'exchangeId073',
        header: 'Exchange',
        style: commonColumnStyle1,
        sortable: true
    },
    {
        field: 'exDividendDateId074',
        header: 'Ex-Div Date',
        style: commonColumnStyle1,
        sortable: true
    },
    {
        field: 'fiscalYearendDateId075',
        header: 'Fiscal Yr End',
        style: commonColumnStyle1,
        sortable: true
    },
    {
        field: 'grahamPriceId076',
        header: 'Graham Price',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'hspYear5Id077',
        header: 'High Price Using 5yr Data',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'hspYear10Id078',
        header: 'High Price Using 10yr Data',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'hspYear15Id079',
        header: 'High Price Using 15yr Data',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'hspYear20Id080',
        header: 'High Price Using 20yr Data',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'industryId081',
        header: 'Industry',
        style: commonColumnStyle1,
        sortable: true
    },
    {
        field: 'longtermDebtId082',
        header: 'LT Debt',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'longtermDebtVsTotalCapitalId083',
        header: 'LT Debt/Total Capital',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'lspYear5Id085',
        header: 'Low Price Using 5yr Data',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'lspYear10Id086',
        header: 'Low Price Using 10yr Data',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'lspYear15Id087',
        header: 'Low Price Using 15yr Data',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'lspYear20Id088',
        header: 'Low Price Using 20yr Data',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'marketId089',
        header: 'Market/Country',
        style: commonColumnStyle1,
        sortable: true
    },
    {
        field: 'marketCapitalisationId090',
        header: 'Market Cap',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'netIncomeId091',
        header: 'Net Income',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'netIncomePerShareId092',
        header: 'Net Income/Share TTM',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'employeesId093',
        header: 'Employees',
        style: commonColumnStyle1,
        sortable: true
    },
    {
        field: 'outstandingSharesCurrentYearId098',
        header: 'Share Outstanding',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'outstandingSharesPreviousYearId099',
        header: 'Share Outstanding (previous Yr)',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'operatingCashflowId100',
        header: 'Operating Cashflow',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'operatingCashflowRatioId101',
        header: 'Operating Cashflow Ratio',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'pcfRatioId103',
        header: 'P/CF Ratio',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'pfcfRatioId105',
        header: 'P/FCF Ratio',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'psRatioId106',
        header: 'P/S Ratio',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'pegRatioYear5Id108',
        header: 'PEG Ratio Using Avg EPS Growth 5yr',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'pegRatioYear10Id109',
        header: 'PEG Ratio Using Avg EPS Growth 10yr',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'pegRatioYear15Id110',
        header: 'PEG Ratio Using Avg EPS Growth 15yr',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'pegRatioYear20Id111',
        header: 'PEG Ratio Using Avg EPS Growth 20yr',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'diffGrahamPriceSharePriceId112',
        header: '% diff Graham Price vs Share Price',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'sharesOwnedInstitutionsId113',
        header: '% Owned by Institutions',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'piotroskiFscoreId114',
        header: 'Piotroski F-Score',
        style: commonColumnStyle1,
        sortable: true
    },
    {
        field: 'profitMarginId115',
        header: 'Total Operating Profit Margin',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'quickRatioId116',
        header: 'Quick Ratio',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'recentDividendPaymentId117',
        header: 'Recent Div Payment',
        style: commonColumnStyle1,
        sortable: true
    },
    {
        field: 'roaTtmId118',
        header: 'ROA TTM',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'rocTtmId119',
        header: 'ROC TTM',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'roeTtmId120',
        header: 'ROE TTM',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'sectorId121',
        header: 'Sector',
        style: commonColumnStyle1,
        sortable: true
    },
    {
        field: 'sharePriceDateId124',
        header: 'Share Date',
        style: commonColumnStyle1,
        sortable: true
    },
    {
        field: 'totalDebtVsEquityRatioId130',
        header: 'Total Debt/Equity Ratio',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'totalStockholderEquityId131',
        header: 'Total Stockholder Equity',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'websiteId136',
        header: 'Website',
        style: commonColumnStyle1,
        sortable: true
    }
]


export const STOCK_DATA_COLUMNS_5TO20 = [

    {
        field: 'codeId129',
        header: 'Stock Symbol',
        style: commonColumnStyle1,
        sortable: true,
        frozen: true,
        body: 'link'
    },
    {
        field: 'companyNameId046',
        header: 'Name',
        style: commonColumnStyle1,
        sortable: true
    },
    {
        field: 'sharePriceId123',
        header: 'Share Price',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'currentDividendYieldId050',
        header: 'Current Div Yld',
        style: commonColumnStyle1,
        sortable: true,
        body: 'dividend'
    },
    {
        field: 'averageEpsGrowthYear5Id015',
        header: 'R5a – Avg EPS Growth 5yr',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'averageEpsGrowthYear10Id016',
        header: 'R5a – Avg EPS Growth 10yr',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'averageEpsGrowthYear15Id017',
        header: 'R5a – Avg EPS Growth 15yr',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'averageEpsGrowthYear20Id018',
        header: 'R5a – Avg EPS Growth 20yr',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'epsIncreasesYear5Id094',
        header: 'R5b – EPS Increases in 5yrs',
        style: commonColumnStyle1,
        sortable: true
    },
    {
        field: 'epsIncreasesYear10Id095',
        header: 'R5b – EPS Increases in 10yrs',
        style: commonColumnStyle1,
        sortable: true
    },
    {
        field: 'epsIncreasesYear15Id096',
        header: 'R5b – EPS Increases in 15yrs',
        style: commonColumnStyle1,
        sortable: true
    },
    {
        field: 'epsIncreasesYear20Id097',
        header: 'R5b – EPS Increases in 20yrs',
        style: commonColumnStyle1,
        sortable: true
    },
    {
        field: 'adgYear5Id006',
        header: 'R6 – Avg Div Growth 5yr',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'adgYear10Id007',
        header: 'R6 – Avg Div Growth 10yr',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'adgYear15Id008',
        header: 'R6 – Avg Div Growth 15yr',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'adgYear20Id009',
        header: 'R6 – Avg Div Growth 20yr',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'payoutRatioId107',
        header: 'R7 – Payout Ratio',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'longtermDebtEquityRatioId084',
        header: 'R8 - LT Debt/Equity',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'afdPreviousId005',
        header: 'R9 - Fwd Dividend vs Prev Year',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'shareBuybackId122',
        header: 'R10 – Share Buyback?',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-buyback'
    },
    {
        field: 'peRatioId104',
        header: 'R11a – P/E Ratio TTM',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'undervaluedVsOvervaluedStatusYear5Id132',
        header: 'R11b – Under/Over Valued Using 5yr Data',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-overvalue'
    },
    {
        field: 'undervaluedVsOvervaluedStatusYear10Id133',
        header: 'R11b – Under/Over Valued Using 10yr Data',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-overvalue'
    },
    {
        field: 'undervaluedVsOvervaluedStatusYear15Id134',
        header: 'R11b – Under/Over Valued Using 15yr Data',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-overvalue'
    },
    {
        field: 'undervaluedVsOvervaluedStatusYear20Id135',
        header: 'R11b – Under/Over Valued Using 20yr Data',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-overvalue'
    },
    {
        field: 'pbRatioId102',
        header: 'R11c – P/B Ratio',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'yearsDividendIncreasesId047',
        header: 'Consecutive Yrs Div Increases',
        style: commonColumnStyle1,
        sortable: true
    }
]


export const STOCK_DATA_COLUMNS_MINIMAL = [
    {
        field: 'codeId129',
        header: 'Stock Symbol',
        style: commonColumnStyle1,
        sortable: true,
        frozen: true,
        body: 'link'
    },
    {
        field: 'companyNameId046',
        header: 'Name',
        style: commonColumnStyle1,
        sortable: true
    },
    {
        field: 'sharePriceId123',
        header: 'Share Price',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'currentDividendYieldId050',
        header: 'Current Div Yld',
        style: commonColumnStyle1,
        sortable: true,
        body: 'dividend'
    },
    {
        field: 'siCriteriaYear20Id128',
        header: 'SI Criteria out of 10 (20yr Data)',
        style: commonColumnStyle1,
        sortable: true
    },
    {
        field: 'siCriteriaYear15Id127',
        header: 'SI Criteria out of 10 (15yr Data)',
        style: commonColumnStyle1,
        sortable: true
    },
    {
        field: 'siCriteriaYear10Id126',
        header: 'SI Criteria out of 10 (10yr Data)',
        style: commonColumnStyle1,
        sortable: true
    },
    {
        field: 'siCriteriaYear5Id125',
        header: 'SI Criteria out of 10 (5yr Data)',
        style: commonColumnStyle1,
        sortable: true
    }
]


export const STOCK_DATA_COLUMNS_COURSE = [
    {
        field: 'codeId129',
        header: 'Stock Symbol',
        style: commonColumnStyle1,
        sortable: true,
        frozen: true,
        body: 'link'
    },
    {
        field: 'companyNameId046',
        header: 'Name',
        style: commonColumnStyle1,
        sortable: true
    },
    {
        field: 'sharePriceId123',
        header: 'Share Price',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'currentDividendYieldId050',
        header: 'Current Div Yld',
        style: commonColumnStyle1,
        sortable: true,
        body: 'dividend'
    }
]


export const STOCK_DATA_COLUMNS_EXTENDED = [
    {
        field: 'codeId129',
        header: 'Stock Symbol',
        style: commonColumnStyle1,
        sortable: true,
        frozen: true,
        body: 'link'
    },
    {
        field: 'companyNameId046',
        header: 'Name',
        style: commonColumnStyle1,
        sortable: true
    },
    {
        field: 'sharePriceId123',
        header: 'Share Price',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'currentDividendYieldId050',
        header: 'Current Div Yld',
        style: commonColumnStyle1,
        sortable: true,
        body: 'dividend'
    },
    {
        field: 'siCriteriaYear20Id128',
        header: 'SI Criteria out of 10 (20yr Data)',
        style: commonColumnStyle1,
        sortable: true
    },
    {
        field: 'siCriteriaYear15Id127',
        header: 'SI Criteria out of 10 (15yr Data)',
        style: commonColumnStyle1,
        sortable: true
    },
    {
        field: 'siCriteriaYear10Id126',
        header: 'SI Criteria out of 10 (10yr Data)',
        style: commonColumnStyle1,
        sortable: true
    },
    {
        field: 'siCriteriaYear5Id125',
        header: 'SI Criteria out of 10 (5yr Data)',
        style: commonColumnStyle1,
        sortable: true
    },
    {
        field: 'averageEpsGrowthYear20Id018',
        header: 'R5a – Avg EPS Growth 20yr',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'averageEpsGrowthYear15Id017',
        header: 'R5a – Avg EPS Growth 15yr',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'averageEpsGrowthYear10Id016',
        header: 'R5a – Avg EPS Growth 10yr',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    }, {
        field: 'averageEpsGrowthYear5Id015',
        header: 'R5a – Avg EPS Growth 5yr',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'epsIncreasesYear20Id097',
        header: 'R5b – EPS Increases in 20yrs',
        style: commonColumnStyle1,
        sortable: true
    },
    {
        field: 'epsIncreasesYear15Id096',
        header: 'R5b – EPS Increases in 15yrs',
        style: commonColumnStyle1,
        sortable: true
    },
    {
        field: 'epsIncreasesYear10Id095',
        header: 'R5b – EPS Increases in 10yrs',
        style: commonColumnStyle1,
        sortable: true
    },
    {
        field: 'epsIncreasesYear5Id094',
        header: 'R5b – EPS Increases in 5yrs',
        style: commonColumnStyle1,
        sortable: true
    },
    {
        field: 'adgYear20Id009',
        header: 'R6 – Avg Div Growth 20yr',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'adgYear15Id008',
        header: 'R6 – Avg Div Growth 15yr',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'adgYear10Id007',
        header: 'R6 – Avg Div Growth 10yr',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'adgYear5Id006',
        header: 'R6 – Avg Div Growth 5yr',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'payoutRatioId107',
        header: 'R7 – Payout Ratio',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'longtermDebtEquityRatioId084',
        header: 'R8 - LT Debt/Equity',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'afdPreviousId005',
        header: 'R9 - Fwd Dividend vs Prev Year',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'shareBuybackId122',
        header: 'R10 – Share Buyback?',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-buyback'
    },
    {
        field: 'peRatioId104',
        header: 'R11a – P/E Ratio TTM',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'undervaluedVsOvervaluedStatusYear20Id135',
        header: 'R11b – Under/Over Valued Using 20yr Data',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-overvalue'
    },
    {
        field: 'undervaluedVsOvervaluedStatusYear15Id134',
        header: 'R11b – Under/Over Valued Using 15yr Data',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-overvalue'
    },
    {
        field: 'undervaluedVsOvervaluedStatusYear10Id133',
        header: 'R11b – Under/Over Valued Using 10yr Data',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-overvalue'
    },
    {
        field: 'undervaluedVsOvervaluedStatusYear5Id132',
        header: 'R11b – Under/Over Valued Using 5yr Data',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-overvalue'
    },
    {
        field: 'pbRatioId102',
        header: 'R11c – P/B Ratio',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'yearsDividendIncreasesId047',
        header: 'Consecutive Yrs Div Increases',
        style: commonColumnStyle1,
        sortable: true
    }
]

export const COLUMN_DEFINITIONS = [
    {
        id: '1',
        uiName: '52wk High',
        name: '52-week High Share Price',
        definition: 'The 52-week high Share Price.'
    },
    {
        id: '2',
        uiName: '52wk Low',
        name: '52-week Low Share Price',
        definition: 'The 52-week low Share Price.'
    },
    {
        id: '3',
        uiName: 'Altman Z-Score',
        name: 'Altman Z-Score',
        definition: 'The Altman Z-score is a formula for determining whether a company, notably in the manufacturing space, is headed for bankruptcy. The formula takes into account profitability, leverage, liquidity, solvency, and activity ratios. An Altman Z-score close to 0 suggests a company might be headed for bankruptcy, while a score closer to 3 suggests a company is in solid financial positioning. The Altman Z-Score is only available for US and CAD companies.'
    },
    {
        id: '4',
        uiName: 'Annual Fwd Dividend',
        name: 'Annual Forward Dividend',
        definition: 'The annual forward dividend per share.'
    },
    {
        id: '5',
        uiName: 'R9 - Fwd Dividend vs Prev Year',
        name: 'Annual Forward Dividend vs Previous Year, Rule #9',
        definition: 'This is Rule #9 from the 12 Rules of Simply Investing. This value calculates the dividend increase (or decrease) in the Annual Forward Dividend compared to the stock\'s previous most recent Annual Dividend per share listed in the company\'s annual report. For example if a stock has an Annual Forward Dividend of $1.64 and its previous year dividend was $1.60, then the value 2.5% will be displayed. There are three other values that can be displayed in this column:\n' +
            '            - "non-dividend stock" will be displayed for stocks that do not pay dividends\n' +
            '        - "dividend eliminated" will be displayed for stocks that paid a dividend in the previous year, but no longer pay a dividend\n' +
            '        - "new dividend" will be displayed for stocks that did not pay a dividend in the previous, but have now started to pay a dividend'
    },
    {
        id: '6',
        uiName: 'R6 - Avg Div Growth 5yr',
        name: 'Average Dividend Growth (5-year), Rule #6',
        definition: 'This is Rule #6 from the 12 Rules of Simply Investing. This value calculates the average dividend growth from the last 5 years.'
    },
    {
        id: '7',
        uiName: 'R6 - Avg Div Growth 10yr',
        name: 'Average Dividend Growth (10-year), Rule #6',
        definition: 'This is Rule #6 from the 12 Rules of Simply Investing. This value calculates the trimmed mean (average) dividend growth from the last 10 years. A trimmed mean (similar to an adjusted mean) is a method of averaging that removes one largest and one smallest value in the set before calculating the mean.'
    },
    {
        id: '8',
        uiName: 'R6 - Avg Div Growth 15yr',
        name: 'Average Dividend Growth (15-year), Rule #6',
        definition: 'This is Rule #6 from the 12 Rules of Simply Investing. This value calculates the trimmed mean (average) dividend growth from the last 15 years. A trimmed mean (similar to an adjusted mean) is a method of averaging that removes one largest and one smallest value in the set before calculating the mean.'
    },
    {
        id: '9',
        uiName: 'R6 - Avg Div Growth 20yr',
        name: 'Average Dividend Growth (20-year), Rule #6',
        definition: 'This is Rule #6 from the 12 Rules of Simply Investing. This value calculates the trimmed mean (average) dividend growth from the last 20 years. A trimmed mean (similar to an adjusted mean) is a method of averaging that removes one largest and one smallest value in the set before calculating the mean.'
    },
    {
        id: '10',
        uiName: 'Avg Div Yld 5yr',
        name: 'Average Dividend Yield (5-year)',
        definition: 'The average dividend yield from the last 5 years.'
    },
    {
        id: '11',
        uiName: 'Avg Div Yld 10yr',
        name: 'Average Dividend Yield (10-year)',
        definition: 'The average dividend yield from the last 10 years.'
    },
    {
        id: '12',
        uiName: 'Avg Div Yld 15yr',
        name: 'Average Dividend Yield (15-year)',
        definition: 'The average dividend yield from the last 15 years.'
    },
    {
        id: '13',
        uiName: 'Avg Div Yld 20yr',
        name: 'Average Dividend Yield (20-year)',
        definition: 'The average dividend yield from the last 20 years.'
    },
    {
        id: '14',
        uiName: 'Avg 3yr EPS',
        name: 'Average EPS for the last 3 years',
        definition: 'Average EPS calculated from the last 3 years.'
    },
    {
        id: '15',
        uiName: 'R5a - Avg EPS Growth 5yr',
        name: 'Average EPS Growth (5-year), Rule #5a',
        definition: 'This is Rule #5a from the 12 Rules of Simply Investing. This value calculates the average EPS growth from the last 5 years.'
    },
    {
        id: '16',
        uiName: 'R5a - Avg EPS Growth 10yr',
        name: 'Average EPS Growth (10-year), Rule #5a',
        definition: 'This is Rule #5a from the 12 Rules of Simply Investing. This value calculates the trimmed mean (average) EPS growth from the last 10 years. A trimmed mean (similar to an adjusted mean) is a method of averaging that removes one largest and one smallest value in the set before calculating the mean.'
    },
    {
        id: '17',
        uiName: 'R5a - Avg EPS Growth 15yr',
        name: 'Average EPS Growth (15-year), Rule #5a',
        definition: 'This is Rule #5a from the 12 Rules of Simply Investing. This value calculates the trimmed mean (average) EPS growth from the last 15 years. A trimmed mean (similar to an adjusted mean) is a method of averaging that removes one largest and one smallest value in the set before calculating the mean.'
    },
    {
        id: '18',
        uiName: 'R5a - Avg EPS Growth 20yr',
        name: 'Average EPS Growth (20-year), Rule #5a',
        definition: 'This is Rule #5a from the 12 Rules of Simply Investing. This value calculates the trimmed mean (average) EPS growth from the last 20 years. A trimmed mean (similar to an adjusted mean) is a method of averaging that removes one largest and one smallest value in the set before calculating the mean.'
    },
    {
        id: '19',
        uiName: 'Avg High Div Yld 5yr',
        name: 'Average High Dividend Yield (5-year)',
        definition: 'The average high dividend yield from the last 5 years.'
    },
    {
        id: '20',
        uiName: 'Avg High Div Yld 10yr',
        name: 'Average High Dividend Yield (10-year)',
        definition: 'The average high dividend yield from the last 10 years.'
    },
    {
        id: '21',
        uiName: 'Avg High Div Yld 15yr',
        name: 'Average High Dividend Yield (15-year)',
        definition: 'The average high dividend yield from the last 15 years.'
    },
    {
        id: '22',
        uiName: 'Avg High Div Yld 20yr',
        name: 'Average High Dividend Yield (20-year)',
        definition: 'The average high dividend yield from the last 20 years.'
    },
    {
        id: '23',
        uiName: 'Avg High P/E 5yr',
        name: 'Average High P/E Ratio (5-years)',
        definition: 'The average high P/E ratio from the last 5 years.'
    },
    {
        id: '24',
        uiName: 'Avg High P/E 10yr',
        name: 'Average High P/E Ratio (10-years)',
        definition: 'The average high P/E ratio from the last 10 years.'
    },
    {
        id: '25',
        uiName: 'Avg High P/E 15yr',
        name: 'Average High P/E Ratio (15-years)',
        definition: 'The average high P/E ratio from the last 15 years.'
    },
    {
        id: '26',
        uiName: 'Avg High P/E 20yr',
        name: 'Average High P/E Ratio (20-years)',
        definition: 'The average high P/E ratio from the last 20 years.'
    },
    {
        id: '27',
        uiName: 'Avg Low Div Yld 5yr',
        name: 'Average Low Dividend Yield (5-year)',
        definition: 'The average low dividend yield from the last 5 years.'
    },
    {
        id: '28',
        uiName: 'Avg Low Div Yld 10yr',
        name: 'Average Low Dividend Yield (10-year)',
        definition: 'The average low dividend yield from the last 10 years.'
    },
    {
        id: '29',
        uiName: 'Avg Low Div Yld 15yr',
        name: 'Average Low Dividend Yield (15-year)',
        definition: 'The average low dividend yield from the last 15 years.'
    },
    {
        id: '30',
        uiName: 'Avg Low Div Yld 20yr',
        name: 'Average Low Dividend Yield (20-year)',
        definition: 'The average low dividend yield from the last 20 years.'
    },
    {
        id: '31',
        uiName: 'Avg Low P/E 5yr',
        name: 'Average Low P/E Ratio (5-years)',
        definition: 'The average low P/E ratio from the last 5 years.'
    },
    {
        id: '32',
        uiName: 'Avg Low P/E 10yr',
        name: 'Average Low P/E Ratio (10-years)',
        definition: 'The average low P/E ratio from the last 10 years.'
    },
    {
        id: '33',
        uiName: 'Avg Low P/E 15yr',
        name: 'Average Low P/E Ratio (15-years)',
        definition: 'The average low P/E ratio from the last 15 years.'
    },
    {
        id: '34',
        uiName: 'Avg Low P/E 20yr',
        name: 'Average Low P/E Ratio (20-years)',
        definition: 'The average low P/E ratio from the last 20 years.'
    },
    {
        id: '35',
        uiName: 'Avg P/E 5yr',
        name: 'Average P/E Ratio (5-years)',
        definition: 'The average P/E ratio from the last 5 years.'
    },
    {
        id: '36',
        uiName: 'Avg P/E 10yr',
        name: 'Average P/E Ratio (10-years)',
        definition: 'The average P/E ratio from the last 10 years.'
    },
    {
        id: '37',
        uiName: 'Avg P/E 15yr',
        name: 'Average P/E Ratio (15-years)',
        definition: 'The average P/E ratio from the last 15 years.'
    },
    {
        id: '38',
        uiName: 'Avg P/E 20yr',
        name: 'Average P/E Ratio (20-years)',
        definition: 'The average P/E ratio from the last 20 years.'
    },
    {
        id: '39',
        uiName: 'Bk Value/Share',
        name: 'Book Value per Share',
        definition: 'Book value per share is the ratio of a company\'s common equity divided by its number of outstanding shares.'
    },
    {
        id: '40',
        uiName: 'Cashflow/Share',
        name: 'Cashflow per Share',
        definition: 'Cash flow per share is calculated by dividing cash flow earned by the total number of outstanding shares.'
    },
    {
        id: '41',
        uiName: 'City',
        name: 'Company Address, City',
        definition: 'This value "City" is part of the company\'s address (typically its corporate headquarters).'
    },
    {
        id: '42',
        uiName: 'Country',
        name: 'Company Address, Country',
        definition: 'This value "Country" is part of the company\'s address (typically its corporate headquarters).'
    },
    {
        id: '43',
        uiName: 'State/Prov',
        name: 'Company Address, State',
        definition: 'This value "State/Province" is part of the company\'s address (typically its corporate headquarters).'
    },
    {
        id: '44',
        uiName: 'Address',
        name: 'Company Address',
        definition: 'This value "Address" is part of the company\'s address (typically its corporate headquarters), typically the building number and street name.'
    },
    {
        id: '45',
        uiName: 'Description',
        name: 'Company Description',
        definition: 'A brief description of the company and it\'s products and services.'
    },
    {
        id: '46',
        uiName: 'Name',
        name: 'Company Name',
        definition: 'The company\'s name.'
    },
    {
        id: '47',
        uiName: 'Consecutive Yrs Div Increases',
        name: 'Consecutive Years of Dividend Increases',
        definition: 'The most recent number of years of consecutive dividend increases.'
    },
    {
        id: '48',
        uiName: 'Consecutive Yrs EPS Increases',
        name: 'Consecutive Years of EPS Increases',
        definition: 'The most recent number of years of consecutive EPS increases.'
    },
    {
        id: '49',
        uiName: 'Current Assets',
        name: 'Current Assets',
        definition: 'This value is calculated using the following formula, Current Assets = (Current Ratio) x (Current Liabilities)'
    },
    {
        id: '50',
        uiName: 'Current Div Yld',
        name: 'Current Dividend Yield',
        definition: 'This value is calculated using the following formula, Current Dividend Yield = (Annual Forward Dividend / Share Price) x 100'
    },
    {
        id: '51',
        uiName: 'Current Debt',
        name: 'Current Liabilities (Current Debt)',
        definition: 'A company\'s current liability (or debt).'
    },
    {
        id: '52',
        uiName: 'Current Ratio',
        name: 'Current Ratio',
        definition: 'This value is calculated using the following formula, Current Ratio = (Current Assets)/(Current Liabilities)'
    },
    {
        id: '53',
        uiName: 'Diff Between Current Div Yld & Avg Div Yld 5yrs',
        name: 'Difference Between Current Dividend Yield and Average Dividend Yield (5-year)',
        definition: 'The difference between current dividend yield and its 5-year average dividend yield, here is the formula: Difference Between Current Dividend Yield and Average Dividend Yield (5-year) = (((Current Dividend Yield) – (Average Dividend Yield 5-year)) / (Average Dividend Yield 5-year)) * 100'
    },
    {
        id: '54',
        uiName: 'Diff Between Current Div Yld & Avg Div Yld 10yrs',
        name: 'Difference Between Current Dividend Yield and Average Dividend Yield (10-year)',
        definition: 'The difference between current dividend yield and its 10-year average dividend yield, here is the formula: Difference Between Current Dividend Yield and Average Dividend Yield (10-year) = (((Current Dividend Yield) – (Average Dividend Yield 10-year)) / (Average Dividend Yield 10-year)) * 100'
    },
    {
        id: '55',
        uiName: 'Diff Between Current Div Yld & Avg Div Yld 15yrs',
        name: 'Difference Between Current Dividend Yield and Average Dividend Yield (15-year)',
        definition: 'The difference between current dividend yield and its 15-year average dividend yield, here is the formula: Difference Between Current Dividend Yield and Average Dividend Yield (15-year) = (((Current Dividend Yield) – (Average Dividend Yield 15-year)) / (Average Dividend Yield 15-year)) * 100'
    },
    {
        id: '56',
        uiName: 'Diff Between Current Div Yld & Avg Div Yld 20yrs',
        name: 'Difference Between Current Dividend Yield and Average Dividend Yield (20-year)',
        definition: 'The difference between current dividend yield and its 20-year average dividend yield, here is the formula: Difference Between Current Dividend Yield and Average Dividend Yield (20-year) = (((Current Dividend Yield) – (Average Dividend Yield 20-year)) / (Average Dividend Yield 20-year)) * 100'
    },
    {
        id: '57',
        uiName: 'Diff Between Current P/E & Avg P/E 5yrs',
        name: 'Difference Between Current P/E Ratio and Average P/E Ratio (5-year)',
        definition: 'The difference between current P/E ratio and its 5-year average P/E ratio.'
    },
    {
        id: '58',
        uiName: 'Diff Between Current P/E & Avg P/E 10yrs',
        name: 'Difference Between Current P/E Ratio and Average P/E Ratio (10-year)',
        definition: 'The difference between current P/E ratio and its 10-year average P/E ratio.'
    },
    {
        id: '59',
        uiName: 'Diff Between Current P/E & Avg P/E 15yrs',
        name: 'Difference Between Current P/E Ratio and Average P/E Ratio (15-year)',
        definition: 'The difference between current P/E ratio and its 15-year average P/E ratio.'
    },
    {
        id: '60',
        uiName: 'Diff Between Current P/E & Avg P/E 20yrs',
        name: 'Difference Between Current P/E Ratio and Average P/E Ratio (20-year)',
        definition: 'The difference between current P/E ratio and its 20-year average P/E ratio.'
    },
    {
        id: '61',
        uiName: 'DCF',
        name: 'Discounted Cashflow',
        definition: 'Discounted cash flow analysis helps to determine the value of an investment based on its future cash flows. The present value of expected future cash flows is calculated using a projected discount rate. If the DCF is higher than the current cost of the investment, the opportunity could result in positive returns and may be worthwhile. A disadvantage of DCF is its reliance on estimations of future cash flows, which could prove inaccurate.'
    },
    {
        id: '62',
        uiName: 'Div Currency',
        name: 'Dividend Currency',
        definition: 'The currency in which the dividend is paid to shareholders.'
    },
    {
        id: '63',
        uiName: 'Div Frequency',
        name: 'Dividend Frequency',
        definition: 'The frequency of the dividend payment.'
    },
    {
        id: '64',
        uiName: 'Div Gr (5yr) + Curr Div Yld',
        name: 'Dividend Growth (5yr) + Current Dividend Yield',
        definition: 'The sum of “5 year Dividend Growth” plus “Current Dividend Yield”'
    },
    {
        id: '65',
        uiName: 'Div Gr (10yr) + Curr Div Yld',
        name: 'Dividend Growth (5yr) + Current Dividend Yield',
        definition: 'The sum of “10 year Dividend Growth” plus “Current Dividend Yield”'
    },
    {
        id: '66',
        uiName: 'Div Gr (15yr) + Curr Div Yld',
        name: 'Dividend Growth (5yr) + Current Dividend Yield',
        definition: 'The sum of “15 year Dividend Growth” plus “Current Dividend Yield”'
    },
    {
        id: '67',
        uiName: 'Div Gr (20yr) + Curr Div Yld',
        name: 'Dividend Growth (5yr) + Current Dividend Yield',
        definition: 'The sum of “20 year Dividend Growth” plus “Current Dividend Yield”'
    },
    {
        id: '68',
        uiName: 'Div Payment Date',
        name: 'Dividend Payment Date',
        definition: 'This is the date that the stock dividend will be paid.'
    },
    {
        id: '69',
        uiName: 'Div Record Date',
        name: 'Dividend Record Date',
        definition: 'To receive a "cash" dividend you must own the stock on the record date.'
    },
    {
        id: '70',
        uiName: 'Divs Paid Since',
        name: 'Dividends Paid Since',
        definition: 'The first year in which the company paid a dividend.'
    },
    {
        id: '71',
        uiName: 'EPS (TTM)',
        name: 'EPS (TTM)',
        definition: 'This value is the company\'s trailing 12-month earnings per share.'
    },
    {
        id: '72',
        uiName: 'ESG Score',
        name: 'ESG Score',
        definition: 'Our data providers’s ESG Ratings are based on a variety of data sources, including corporate sustainability reports, ESG research firms, and government agencies. This value is only available for US stocks.'
    },
    {
        id: '73',
        uiName: 'Exchange',
        name: 'Exchange',
        definition: 'The stock exchange on which a company\'s stock trades in.'
    },
    {
        id: '74',
        uiName: 'Ex-Div Date',
        name: 'Ex-Dividend Date',
        definition: 'This date will always be the first trading day following the "dividend payment date."'
    },
    {
        id: '75',
        uiName: 'Fiscal Yr End',
        name: 'Fiscal Year-End Date',
        definition: 'A company\'s fiscal year-end date.'
    },
    {
        id: '76',
        uiName: 'Graham Price',
        name: 'Graham Price',
        definition: 'Graham Price = square root of (average of 3 years of EPS x Book Value per share x 22.5). The Graham price will be "N/A" if any of the following two conditions are true:\n' +
            '        - If (Average EPS for the last 3 years) = 0 or negative\n' +
            '        - If (Book Value per Share) = 0 or negative'
    },
    {
        id: '77',
        uiName: 'High Price Using 5yr Data',
        name: 'High Stock Price (based on 5-year data)',
        definition: 'For dividend-paying stocks, High Stock Price based on the stock’s 5-year average low dividend yield. For non-dividend paying stocks, High Stock Price based on the stock’s 5-year average high P/E ratio.'
    },
    {
        id: '78',
        uiName: 'High Price Using 10yr Data',
        name: 'High Stock Price (based on 10-year data)',
        definition: 'For dividend-paying stocks, High Stock Price based on the stock’s 10-year average low dividend yield. For non-dividend paying stocks, High Stock Price based on the stock’s 10-year average high P/E ratio.'
    },
    {
        id: '79',
        uiName: 'High Price Using 15yr Data',
        name: 'High Stock Price (based on 15-year data)',
        definition: 'For dividend-paying stocks, High Stock Price based on the stock’s 15-year average low dividend yield. For non-dividend paying stocks, High Stock Price based on the stock’s 15-year average high P/E ratio.'
    },
    {
        id: '80',
        uiName: 'High Price Using 20yr Data',
        name: 'High Stock Price (based on 20-year data)',
        definition: 'For dividend-paying stocks, High Stock Price based on the stock’s 20-year average low dividend yield. For non-dividend paying stocks, High Stock Price based on the stock’s 20-year average high P/E ratio.'
    },
    {
        id: '81',
        uiName: 'Industry',
        name: 'Industry',
        definition: 'The industry the stock belongs to based on the Global Industry Classification Standard.'
    },
    {
        id: '82',
        uiName: 'LT Debt',
        name: 'Long-term Debt',
        definition: 'A company\'s long-term debt. Long-term debts, also called long-term liabilities, are debts a company owes third-party creditors that are payable beyond 12 months.'
    },
    {
        id: '83',
        uiName: 'LT Debt/Total Capital',
        name: 'Long-term Debt to Total Capital',
        definition: 'A Long Term Debt to Capitalization Ratio is the ratio that shows the financial leverage of the firm. This ratio is calculated by dividing the long term debt with the total capital available of a company.'
    },
    {
        id: '84',
        uiName: 'R8 - LT Debt/Equity',
        name: 'Long-term Debt/Equity Ratio, Rule #8',
        definition: 'This is Rule #8 from the 12 Rules of Simply Investing. This value calculates the long-term debt to shareholder equity ratio.'
    },
    {
        id: '85',
        uiName: 'Low Price Using 5yr Data',
        name: 'Low Stock Price (based on 5-year data)',
        definition: 'For dividend-paying stocks, Low Stock Price based on the stock’s 5-year average high dividend yield. For non-dividend paying stocks, Low Stock Price based on the stock’s 5-year average low P/E ratio.'
    },
    {
        id: '86',
        uiName: 'Low Price Using 10yr Data',
        name: 'Low Stock Price (based on 10-year data)',
        definition: 'For dividend-paying stocks, Low Stock Price based on the stock’s 10-year average high dividend yield. For non-dividend paying stocks, Low Stock Price based on the stock’s 10-year average low P/E ratio.'
    },
    {
        id: '87',
        uiName: 'Low Price Using 15yr Data',
        name: 'Low Stock Price (based on 15-year data)',
        definition: 'For dividend-paying stocks, Low Stock Price based on the stock’s 15-year average high dividend yield. For non-dividend paying stocks, Low Stock Price based on the stock’s 15-year average low P/E ratio.'
    },
    {
        id: '88',
        uiName: 'Low Price Using 20yr Data',
        name: 'Low Stock Price (based on 20-year data)',
        definition: 'For dividend-paying stocks, Low Stock Price based on the stock’s 20-year average high dividend yield. For non-dividend paying stocks, Low Stock Price based on the stock’s 20-year average low P/E ratio.'
    },
    {
        id: '89',
        uiName: 'Market/Country',
        name: 'Market (Country)',
        definition: 'The market/country that the stock is trading in.'
    },
    {
        id: '90',
        uiName: 'Market Cap',
        name: 'Market Capitalization',
        definition: 'Market capitalization, commonly called market cap, is the market value of a publicly traded company\'s outstanding shares. Market capitalization is equal to the share price multiplied by the number of shares outstanding.'
    },
    {
        id: '91',
        uiName: 'Net Income',
        name: 'Net Income',
        definition: 'Net income, also called net earnings, is calculated as sales minus cost of goods sold, selling, general and administrative expenses, operating expenses, depreciation, interest, taxes, and other expenses. It is a useful number for investors to assess how much revenue exceeds the expenses of an organization. This number appears on a company\'s income statement and is also an indicator of a company\'s profitability.'
    },
    {
        id: '92',
        uiName: 'Net Income/Share TTM',
        name: 'Net Income Per Share TTM',
        definition: 'The earnings, or profits, as reported by the company, for the trailing 12 months per share. Net income reflects the income available for the common stockholders.'
    },
    {
        id: '93',
        uiName: 'Employees',
        name: 'Number of Employees',
        definition: 'The number of employees employed at the company.'
    },
    {
        id: '94',
        uiName: 'R5b - EPS Increases in 5yrs',
        name: 'Number of EPS increases in the last 5-years, Rule #5b',
        definition: 'This is Rule #5b from the 12 Rules of Simply Investing. This value calculates the number of EPS increases in the last 5-years.'
    },
    {
        id: '95',
        uiName: 'R5b - EPS Increases in 10yrs',
        name: 'Number of EPS increases in the last 10-years, Rule #5b',
        definition: 'This is Rule #5b from the 12 Rules of Simply Investing. This value calculates the number of EPS increases in the last 10-years.'
    },
    {
        id: '96',
        uiName: 'R5b - EPS Increases in 15yrs',
        name: 'Number of EPS increases in the last 15-years, Rule #5b',
        definition: 'This is Rule #5b from the 12 Rules of Simply Investing. This value calculates the number of EPS increases in the last 15-years.'
    },
    {
        id: '97',
        uiName: 'R5b - EPS Increases in 20yrs',
        name: 'Number of EPS increases in the last 20-years, Rule #5b',
        definition: 'This is Rule #5b from the 12 Rules of Simply Investing. This value calculates the number of EPS increases in the last 20-years.'
    },
    {
        id: '98',
        uiName: 'Share Outstanding',
        name: 'Number of outstanding shares (Current Year)',
        definition: 'The current number of outstanding shares in the company.'
    },
    {
        id: '99',
        uiName: 'Share Outstanding (previous Yr)',
        name: 'Number of outstanding shares (Previous Year)',
        definition: 'The number of outstanding shares in the company in the previous year.'
    },
    {
        id: '100',
        uiName: 'Operating Cashflow',
        name: 'Operating Cash Flow',
        definition: 'Operating cash flow (OCF) is a measure of the amount of cash generated by a company\'s normal business operations.'
    },
    {
        id: '101',
        uiName: 'Operating Cashflow Ratio',
        name: 'Operating Cash Flow Ratio',
        definition: 'The operating cash flow ratio is a measure of how readily current liabilities are covered by the cash flows generated from a company\'s operations. This ratio can help gauge a company\'s liquidity in the short term.'
    },
    {
        id: '102',
        uiName: 'R11c - P/B Ratio',
        name: 'P/B Ratio, Rule #11.c',
        definition: 'This is Rule #11c from the 12 Rules of Simply Investing. This value calculates the P/B Ratio = (Share Price) / (Book Value per Share)'
    },
    {
        id: '103',
        uiName: 'P/CF Ratio',
        name: 'P/CF Ratio',
        definition: 'The price to cashflow (P/CF) ratio is a stock valuation indicator or multiple that measures the value of a stock’s price relative to its operating cash flow per share.'
    },
    {
        id: '104',
        uiName: 'R11a - P/E Ratio TTM',
        name: 'P/E Ratio (TTM), Rule #11.a',
        definition: 'This is Rule #11a from the 12 Rules of Simply Investing. This value calculates the P/E Ratio = (Share Price) / (EPS ttm)'
    },
    {
        id: '105',
        uiName: 'P/FCF Ratio',
        name: 'P/FCF Ratio',
        definition: 'Price to free cashflow is an equity valuation metric used to compare a company\'s per-share market price to its per-share amount of free cashflow (FCF). This metric is very similar to the valuation metric of price to cash flow but is considered a more exact measure, owing to the fact that it uses free cash flow, which subtracts capital expenditures (CAPEX) from a company\'s total operating cash flow, thereby reflecting the actual cash flow available to fund non-asset-related growth.'
    },
    {
        id: '106',
        uiName: 'P/S Ratio',
        name: 'P/S Ratio',
        definition: 'The price-to-sales (P/S) ratio is a valuation ratio that compares a company’s stock price to its revenues.'
    },
    {
        id: '107',
        uiName: 'R7 - Payout Ratio',
        name: 'Payout Ratio, Rule #7',
        definition: 'This is Rule #7 from the 12 Rules of Simply Investing. This value calculates the Payout Ratio = ((Annual Forward Dividend) / (EPS ttm)) x 100'
    },
    {
        id: '108',
        uiName: 'PEG Ratio Using Avg EPS Growth 5yr',
        name: 'PEG Ratio (based on Average EPS Growth 5-years)',
        definition: 'The price/earnings to growth ratio (PEG ratio) is a stock\'s price-to-earnings (P/E) ratio divided by the growth rate of its earnings for the last 5-years.'
    },
    {
        id: '109',
        uiName: 'PEG Ratio Using Avg EPS Growth 10yr',
        name: 'PEG Ratio (based on Average EPS Growth 10-years)',
        definition: 'The price/earnings to growth ratio (PEG ratio) is a stock\'s price-to-earnings (P/E) ratio divided by the growth rate of its earnings for the last 10-years.'
    },
    {
        id: '110',
        uiName: 'PEG Ratio Using Avg EPS Growth 15yr',
        name: 'PEG Ratio (based on Average EPS Growth 15-years)',
        definition: 'The price/earnings to growth ratio (PEG ratio) is a stock\'s price-to-earnings (P/E) ratio divided by the growth rate of its earnings for the last 15-years.'
    },
    {
        id: '111',
        uiName: 'PEG Ratio Using Avg EPS Growth 20yr',
        name: 'PEG Ratio (based on Average EPS Growth 20-years)',
        definition: 'The price/earnings to growth ratio (PEG ratio) is a stock\'s price-to-earnings (P/E) ratio divided by the growth rate of its earnings for the last 20-years.'
    },
    {
        id: '112',
        uiName: '% diff Graham Price vs Share Price',
        name: 'Percent difference between Graham Price vs Share Price',
        definition: 'The percent difference between the Graham Price and the Share Price. This value will not be displayed if the Graham Price is "N/A".'
    },
    {
        id: '113',
        uiName: '% Owned by Institutions',
        name: 'Percent of Shares Owned by Institutions',
        definition: 'Percentage of shares owned by institutions. This value is only available for US stocks.'
    },
    {
        id: '114',
        uiName: 'Piotroski F-Score',
        name: 'Piotroski F-Score',
        definition: 'The Piotroski score is a discrete score between zero and nine that reflects nine criteria used to determine the strength of a firm\'s financial position. The Piotroski score was named after the Chicago accounting professor Joseph Piotroski, who devised the scale, according to specific aspects of company financial statements. Aspects are focused on the company’s accounting results in recent time periods (years). For every criterion met, one point is awarded. Otherwise, no points are awarded. The points are then added up to determine the best value stocks. If a company has a score of eight or nine, it is considered a good value. If a company has a score of between zero and two points, it is likely not a good value.'
    },
    {
        id: '115',
        uiName: 'Total Operating Profit Margin',
        name: 'Profit Margin (Total Operating)',
        definition: 'Operating Profit Margin is a profitability or performance ratio that reflects the percentage of profit a company produces from its operations, prior to subtracting taxes and interest charges. It is calculated by dividing the operating profit by total revenue and expressing it as a percentage. The margin is also known as EBIT (Earnings Before Interest and Tax) Margin.'
    },
    {
        id: '116',
        uiName: 'Quick Ratio',
        name: 'Quick Ratio',
        definition: 'The Quick Ratio, also known as the Acid-test or Liquidity ratio, measures the ability of a business to pay its short-term liabilities by having assets that are readily convertible into cash. These assets are, namely, cash, marketable securities, and accounts receivable. These assets are known as “quick” assets since they can quickly be converted into cash.'
    },
    {
        id: '117',
        uiName: 'Recent Div Payment',
        name: 'Recent Dividend Payment',
        definition: 'The amount of the most recent dividend paid to shareholders.'
    },
    {
        id: '118',
        uiName: 'ROA TTM',
        name: 'ROA (TTM)',
        definition: 'Return on Assets (ROA) is a type of return on investment (ROI) metric that measures the profitability of a business in relation to its total assets. This ratio indicates how well a company is performing by comparing the profit (net income) it’s generating to the capital it’s invested in assets.'
    },
    {
        id: '119',
        uiName: 'ROC TTM',
        name: 'ROC (TTM)',
        definition: 'Return on capital, or Return on invested capital (ROIC) is a calculation used to assess a company\'s efficiency at allocating the capital under its control to profitable investments. The return on invested capital ratio gives a sense of how well a company is using its capital to generate profits.'
    },
    {
        id: '120',
        uiName: 'ROE TTM',
        name: 'ROE (TTM)',
        definition: 'Return on Equity (ROE) is the measure of a company’s annual return (net income) divided by the value of its total shareholders’ equity.'
    },
    {
        id: '121',
        uiName: 'Sector',
        name: 'Sector',
        definition: 'Sector security belongs to based on the Global Industry Classification Standard.'
    },
    {
        id: '122',
        uiName: 'R10 - Share Buyback?',
        name: 'Share Buyback?, Rule #10',
        definition: 'This is Rule #10 from the 12 Rules of Simply Investing. This value determined based on the following two parameters:\n' +
            '            - if (Number of outstanding shares in the current year) is less than (Number of outstanding shares in the previous year) then "yes"\n' +
            '        - if (Number of outstanding shares in the current year) is greater than or equal to (Number of outstanding shares in the previous year) then "no"'
    },
    {
        id: '123',
        uiName: 'Share Price',
        name: 'Share Price',
        definition: 'The share price at the end of business day, business day is referred to as the day when the stock market is open.'
    },
    {
        id: '124',
        uiName: 'Share Date',
        name: 'Share Price Date',
        definition: 'Date of the Share Price'
    },
    {
        id: '125',
        uiName: 'SI Criteria out of 10 (5yr Data)',
        name: 'SI Criteria (out of 10) using 5-year data',
        definition: 'The SI Criteria maximum grade out of 10, based on 5-year data.'
    },
    {
        id: '126',
        uiName: 'SI Criteria out of 10 (10yr Data)',
        name: 'SI Criteria (out of 10) using 10-year data',
        definition: 'The SI Criteria maximum grade out of 10, based on 10-year data.'
    },
    {
        id: '127',
        uiName: 'SI Criteria out of 10 (15yr Data)',
        name: 'SI Criteria (out of 10) using 15-year data',
        definition: 'The SI Criteria maximum grade out of 10, based on 15-year data.'
    },
    {
        id: '128',
        uiName: 'SI Criteria out of 10 (20yr Data)',
        name: 'SI Criteria (out of 10) using 20-year data',
        definition: 'The SI Criteria maximum grade out of 10, based on 20-year data.'
    },
    {
        id: '129',
        uiName: 'Stock Symbol',
        name: 'Stock Symbol',
        definition: 'The stock symbol.'
    },
    {
        id: '130',
        uiName: 'Total Debt/Equity Ratio',
        name: 'Total Debt to Equity Ratio',
        definition: 'The Debt to Equity ratio (also called the “debt-equity ratio”, “risk ratio”, or “D/E”), is a leverage ratio that calculates the weight of total debt and financial liabilities against total shareholders’ equity.'
    },
    {
        id: '131',
        uiName: 'Total Stockholder Equity',
        name: 'Total Stockholder\'s Equity',
        definition: 'Stockholders Equity (also known as Shareholders Equity) is an account on a company’s balance sheet that consists of share capital plus retained earnings. It also represents the residual value of assets minus liabilities. By rearranging the original accounting equation, Assets = Liabilities + Stockholders Equity, it can also be expressed as Stockholders Equity = Assets – Liabilities.'
    },
    {
        id: '132',
        uiName: 'R11b - Under/Over Valued Using 5yr Data',
        name: 'Undervalued or Overvalued (based on 5-year data), Rule #11.b',
        definition: 'This is Rule #11b from the 12 Rules of Simply Investing. This value is determined based on the following parameters:' +
            '<br/><br/>            A stock is considered a "dividend stock" if its "Annual Forward Dividend vs Previous Year, Rule #9" is not equal to "non-dividend stock" or "dividend eliminated" or "new dividend".' +
            '<br/><br/>            A stock is considered a "non-dividend stock" if its "Annual Forward Dividend vs Previous Year, Rule #9" is equal to "non-dividend stock" or "dividend eliminated" or "new dividend".' +
            '<br/>        - for dividend stocks, if (Current Dividend Yield) is greater than (Average Dividend Yield 5-year) then "undervalued"' +
            '<br/>        - for dividend stocks, if (Current Dividend Yield) is less than or equal to (Average Dividend Yield 5-year) then "overvalued"' +
            '<br/>        - for non-dividend stocks, if (P/E Ratio TTM) is less than (Average P/E Ratio 5-years) then “undervalued”' +
            '\t- for non-dividend stocks, if (P/E Ratio TTM) is greater than or equal to (Average P/E Ratio 5-years) then “overvalued”'
    },
    {
        id: '133',
        uiName: 'R11b - Under/Over Valued Using 10yr Data',
        name: 'Undervalued or Overvalued (based on 10-year data), Rule #11.b',
        definition: 'This is Rule #11b from the 12 Rules of Simply Investing. This value is determined based on the following parameters:' +
            '<br/><br/>            A stock is considered a "dividend stock" if its "Annual Forward Dividend vs Previous Year, Rule #9" is not equal to "non-dividend stock" or "dividend eliminated" or "new dividend".' +
            '<br/><br/>            A stock is considered a "non-dividend stock" if its "Annual Forward Dividend vs Previous Year, Rule #9" is equal to "non-dividend stock" or "dividend eliminated" or "new dividend".' +
            '<br/>        - for dividend stocks, if (Current Dividend Yield) is greater than (Average Dividend Yield 10-year) then "undervalued"' +
            '<br/>        - for dividend stocks, if (Current Dividend Yield) is less than or equal to (Average Dividend Yield 10-year) then "overvalued"' +
            '<br/>        - for non-dividend stocks, if (P/E Ratio TTM) is less than (Average P/E Ratio 10-years) then “undervalued”' +
            '\t- for non-dividend stocks, if (P/E Ratio TTM) is greater than or equal to (Average P/E Ratio 10-years) then “overvalued”'
    },
    {
        id: '134',
        uiName: 'R11b - Under/Over Valued Using 15yr Data',
        name: 'Undervalued or Overvalued (based on 15-year data), Rule #11.b',
        definition: 'This is Rule #11b from the 12 Rules of Simply Investing. This value is determined based on the following parameters:' +
            '<br/><br/>            A stock is considered a "dividend stock" if its "Annual Forward Dividend vs Previous Year, Rule #9" is not equal to "non-dividend stock" or "dividend eliminated" or "new dividend".' +
            '<br/><br/>            A stock is considered a "non-dividend stock" if its "Annual Forward Dividend vs Previous Year, Rule #9" is equal to "non-dividend stock" or "dividend eliminated" or "new dividend".' +
            '<br/>        - for dividend stocks, if (Current Dividend Yield) is greater than (Average Dividend Yield 15-year) then "undervalued"' +
            '<br/>        - for dividend stocks, if (Current Dividend Yield) is less than or equal to (Average Dividend Yield 15-year) then "overvalued"' +
            '<br/>        - for non-dividend stocks, if (P/E Ratio TTM) is less than (Average P/E Ratio 15-years) then “undervalued”' +
            '\t- for non-dividend stocks, if (P/E Ratio TTM) is greater than or equal to (Average P/E Ratio 15-years) then “overvalued”'
    },
    {
        id: '135',
        uiName: 'R11b - Under/Over Valued Using 20yr Data',
        name: 'Undervalued or Overvalued (based on 20-year data), Rule #11.b',
        definition: 'This is Rule #11b from the 12 Rules of Simply Investing. This value is determined based on the following parameters:' +
            '<br/><br/>            A stock is considered a "dividend stock" if its "Annual Forward Dividend vs Previous Year, Rule #9" is not equal to "non-dividend stock" or "dividend eliminated" or "new dividend".' +
            '<br/><br/>            A stock is considered a "non-dividend stock" if its "Annual Forward Dividend vs Previous Year, Rule #9" is equal to "non-dividend stock" or "dividend eliminated" or "new dividend".' +
            '<br/>        - for dividend stocks, if (Current Dividend Yield) is greater than (Average Dividend Yield 20-year) then "undervalued"' +
            '<br/>        - for dividend stocks, if (Current Dividend Yield) is less than or equal to (Average Dividend Yield 20-year) then "overvalued"' +
            '<br/>        - for non-dividend stocks, if (P/E Ratio TTM) is less than (Average P/E Ratio 20-years) then “undervalued”' +
            '\t- for non-dividend stocks, if (P/E Ratio TTM) is greater than or equal to (Average P/E Ratio 20-years) then “overvalued”'
    },
    {
        id: '136',
        uiName: 'Website',
        name: 'Website',
        definition: 'The link (URL) to the company\'s corporate website.'
    },

]


export const STOCK_DATA_COLUMNS_BASIC_SEARCH = [
    {
        field: 'codeId129',
        header: 'Stock Symbol',
        style: commonColumnStyle1,
        sortable: true,
        frozen: true,
        body: 'link'
    },
    {
        field: 'companyNameId046',
        header: 'Name',
        style: commonColumnStyle1,
        sortable: true
    },
    {
        field: 'sharePriceId123',
        header: 'Share Price',
        style: commonColumnStyle1,
        sortable: true,
        body: 'format-number'
    },
    {
        field: 'currentDividendYieldId050',
        header: 'Current Div Yld',
        style: commonColumnStyle1,
        sortable: true,
        body: 'dividend'
    }
]

export const STOCK_CODES = [
    {name: '52wk High', code: 'hspWeek52Id001'},
    {name: '52wk Low', code: 'lspWeek52Id002'},
    {name: 'Altman Z-Score', code: 'altmanZscoreId003'},
    {name: 'Annual Fwd Dividend', code: 'afdId004'},
    {name: 'R9 - Fwd Dividend vs Prev Year', code: 'afdPreviousId005'},
    {name: 'R6 - Avg Div Growth 5yr', code: 'adgYear5Id006'},
    {name: 'R6 - Avg Div Growth 10yr', code: 'adgYear10Id007'},
    {name: 'R6 - Avg Div Growth 15yr', code: 'adgYear15Id008'},
    {name: 'R6 - Avg Div Growth 20yr', code: 'adgYear20Id009'},
    {name: 'Avg Div Yld 5yr', code: 'adyYear5Id010'},
    {name: 'Avg Div Yld 10yr', code: 'adyYear10Id011'},
    {name: 'Avg Div Yld 15yr', code: 'adyYear15Id012'},
    {name: 'Avg Div Yld 20yr', code: 'adyYear20Id013'},
    {name: 'Avg 3yr EPS', code: 'averageEpsYear3Id014'},
    {name: 'R5a - Avg EPS Growth 5yr', code: 'averageEpsGrowthYear5Id015'},
    {name: 'R5a - Avg EPS Growth 10yr', code: 'averageEpsGrowthYear10Id016'},
    {name: 'R5a - Avg EPS Growth 15yr', code: 'averageEpsGrowthYear15Id017'},
    {name: 'R5a - Avg EPS Growth 20yr', code: 'averageEpsGrowthYear20Id018'},
    {name: 'Avg High Div Yld 5yr', code: 'averageHdyYear5Id019'},
    {name: 'Avg High Div Yld 10yr', code: 'averageHdyYear10Id020'},
    {name: 'Avg High Div Yld 15yr', code: 'averageHdyYear15Id021'},
    {name: 'Avg High Div Yld 20yr', code: 'averageHdyYear20Id022'},
    {name: 'Avg High P/E 5yr', code: 'averageHighPeRatioYear5Id023'},
    {name: 'Avg High P/E 10yr', code: 'averageHighPeRatioYear10Id024'},
    {name: 'Avg High P/E 15yr', code: 'averageHighPeRatioYear15Id025'},
    {name: 'Avg High P/E 20yr', code: 'averageHighPeRatioYear20Id026'},
    {name: 'Avg Low Div Yld 5yr', code: 'averageLdyYear5Id027'},
    {name: 'Avg Low Div Yld 10yr', code: 'averageLdyYear10Id028'},
    {name: 'Avg Low Div Yld 15yr', code: 'averageLdyYear15Id029'},
    {name: 'Avg Low Div Yld 20yr', code: 'averageLdyYear20Id030'},
    {name: 'Avg Low P/E 5yr', code: 'averageLowPeRatioYear5Id031'},
    {name: 'Avg Low P/E 10yr', code: 'averageLowPeRatioYear10Id032'},
    {name: 'Avg Low P/E 15yr', code: 'averageLowPeRatioYear15Id033'},
    {name: 'Avg Low P/E 20yr', code: 'averageLowPeRatioYear20Id034'},
    {name: 'Avg P/E 5yr', code: 'averagePeRatioYear5Id035'},
    {name: 'Avg P/E 10yr', code: 'averagePeRatioYear10Id036'},
    {name: 'Avg P/E 15yr', code: 'averagePeRatioYear15Id037'},
    {name: 'Avg P/E 20yr', code: 'averagePeRatioYear20Id038'},
    {name: 'Bk Value/Share', code: 'bookValuePerShareId039'},
    {name: 'Cashflow/Share', code: 'cashFlowPerShareId040'},
    {name: 'City', code: 'companyAddressCityId041'},
    {name: 'Country', code: 'companyAddressCountryId042'},
    {name: 'State/Prov', code: 'companyAddressStateId043'},
    {name: 'Address', code: 'companyAddressId044'},
    {name: 'Description', code: 'companyDescriptionId045'},
    {name: 'Name', code: 'companyNameId046'},
    {name: 'Consecutive Yrs Div Increases', code: 'yearsDividendIncreasesId047'},
    {name: 'Consecutive Yrs EPS Increases', code: 'yearsEpsIncreasesId048'},
    {name: 'Current Assets', code: 'currentAssetsId049'},
    {name: 'Current Div Yld', code: 'currentDividendYieldId050'},
    {name: 'Current Debt', code: 'currentLiabilitiesId051'},
    {name: 'Current Ratio', code: 'currentRatioId052'},
    {name: 'Diff Between Current Div Yld & Avg Div Yld 5yrs', code: 'diffDyCurrentVsAverageYear5Id053'},
    {name: 'Diff Between Current Div Yld & Avg Div Yld 10yrs', code: 'diffDyCurrentVsAverageYear10Id054'},
    {name: 'Diff Between Current Div Yld & Avg Div Yld 15yrs', code: 'diffDyCurrentVsAverageYear15Id055'},
    {name: 'Diff Between Current Div Yld & Avg Div Yld 20yrs', code: 'diffDyCurrentVsAverageYear20Id056'},
    {name: 'Diff Between Current P/E & Avg P/E 5yrs', code: 'diffPeCurrentVsAverageYear5Id057'},
    {name: 'Diff Between Current P/E & Avg P/E 10yrs', code: 'diffPeCurrentVsAverageYear10Id058'},
    {name: 'Diff Between Current P/E & Avg P/E 15yrs', code: 'diffPeCurrentVsAverageYear15Id059'},
    {name: 'Diff Between Current P/E & Avg P/E 20yrs', code: 'diffPeCurrentVsAverageYear20Id060'},
    {name: 'DCF', code: 'dcfId061'},
    {name: 'Div Currency', code: 'dividendCurrencyId062'},
    {name: 'Div Frequency', code: 'dividendFrequencyId063'},
    {name: 'Div Gr (5yr) + Curr Div Yld', code: 'dgPlusDyYear5Id064'},
    {name: 'Div Gr (10yr) + Curr Div Yld', code: 'dgPlusDyYear10Id065'},
    {name: 'Div Gr (15yr) + Curr Div Yld', code: 'dgPlusDyYear15Id066'},
    {name: 'Div Gr (20yr) + Curr Div Yld', code: 'dgPlusDyYear20Id067'},
    {name: 'Div Payment Date', code: 'dividendPaymentDateId068'},
    {name: 'Div Record Date', code: 'dividendRecordDateId069'},
    {name: 'Divs Paid Since', code: 'dividendPaidId070'},
    {name: 'EPS (TTM)', code: 'epsTtmId071'},
    {name: 'ESG Score', code: 'esgScoreId072'},
    {name: 'Ex-Div Date', code: 'exDividendDateId074'},
    {name: 'Fiscal Yr End', code: 'fiscalYearendDateId075'},
    {name: 'Graham Price', code: 'grahamPriceId076'},
    {name: 'High Price Using 5yr Data', code: 'hspYear5Id077'},
    {name: 'High Price Using 10yr Data', code: 'hspYear10Id078'},
    {name: 'High Price Using 15yr Data', code: 'hspYear15Id079'},
    {name: 'High Price Using 20yr Data', code: 'hspYear20Id080'},
    {name: 'Industry', code: 'industryId081'},
    {name: 'LT Debt', code: 'longtermDebtId082'},
    {name: 'LT Debt/Total Capital', code: 'longtermDebtVsTotalCapitalId083'},
    {name: 'R8 - LT Debt/Equity', code: 'longtermDebtEquityRatioId084'},
    {name: 'Low Price Using 5yr Data', code: 'lspYear5Id085'},
    {name: 'Low Price Using 10yr Data', code: 'lspYear10Id086'},
    {name: 'Low Price Using 15yr Data', code: 'lspYear15Id087'},
    {name: 'Low Price Using 20yr Data', code: 'lspYear20Id088'},
    {name: 'Market/Country', code: 'marketId089'},
    {name: 'Market Cap', code: 'marketCapitalisationId090'},
    {name: 'Net Income', code: 'netIncomeId091'},
    {name: 'Net Income/Share TTM', code: 'netIncomePerShareId092'},
    {name: 'Employees', code: 'employeesId093'},
    {name: 'R5b - EPS Increases in 5yrs', code: 'epsIncreasesYear5Id094'},
    {name: 'R5b - EPS Increases in 10yrs', code: 'epsIncreasesYear10Id095'},
    {name: 'R5b - EPS Increases in 15yrs', code: 'epsIncreasesYear15Id096'},
    {name: 'R5b - EPS Increases in 20yrs', code: 'epsIncreasesYear20Id097'},
    {name: 'Share Outstanding', code: 'outstandingSharesCurrentYearId098'},
    {name: 'Share Outstanding (previous Yr) ', code: 'outstandingSharesPreviousYearId099'},
    {name: 'Operating Cashflow', code: 'operatingCashflowId100'},
    {name: 'Operating Cashflow Ratio', code: 'operatingCashflowRatioId101'},
    {name: 'R11c - P/B Ratio', code: 'pbRatioId102'},
    {name: 'P/CF Ratio', code: 'pcfRatioId103'},
    {name: 'R11a - P/E Ratio TTM', code: 'peRatioId104'},
    {name: 'P/FCF Ratio', code: 'pfcfRatioId105'},
    {name: 'P/S Ratio', code: 'psRatioId106'},
    {name: 'R7 - Payout Ratio', code: 'payoutRatioId107'},
    {name: 'PEG Ratio Using Avg EPS Growth 5yr', code: 'pegRatioYear5Id108'},
    {name: 'PEG Ratio Using Avg EPS Growth 10yr', code: 'pegRatioYear10Id109'},
    {name: 'PEG Ratio Using Avg EPS Growth 15yr', code: 'pegRatioYear15Id110'},
    {name: 'PEG Ratio Using Avg EPS Growth 20yr', code: 'pegRatioYear20Id111'},
    {name: '% diff Graham Price vs Share Price', code: 'diffGrahamPriceSharePriceId112'},
    {name: '% Owned by Institutions', code: 'sharesOwnedInstitutionsId113'},
    {name: 'Piotroski F-Score', code: 'piotroskiFscoreId114'},
    {name: 'Total Operating Profit Margin', code: 'profitMarginId115'},
    {name: 'Quick Ratio', code: 'quickRatioId116'},
    {name: 'Recent Div Payment', code: 'recentDividendPaymentId117'},
    {name: 'ROA TTM', code: 'roaTtmId118'},
    {name: 'ROC TTM', code: 'rocTtmId119'},
    {name: 'ROE TTM', code: 'roeTtmId120'},
    {name: 'Sector', code: 'sectorId121'},
    {name: 'R10 - Share Buyback?', code: 'shareBuybackId122'},
    {name: 'Share Price', code: 'sharePriceId123'},
    {name: 'Share Date', code: 'sharePriceDateId124'},
    {name: 'SI Criteria out of 10 (5yr Data)', code: 'siCriteriaYear5Id125'},
    {name: 'SI Criteria out of 10 (10yr Data)', code: 'siCriteriaYear10Id126'},
    {name: 'SI Criteria out of 10 (15yr Data)', code: 'siCriteriaYear15Id127'},
    {name: 'SI Criteria out of 10 (20yr Data)', code: 'siCriteriaYear20Id128'},
    {name: 'Total Debt/Equity Ratio', code: 'totalDebtVsEquityRatioId130'},
    {name: 'Total Stockholder Equity', code: 'totalStockholderEquityId131'},
    {name: 'R11b - Under/Over Valued Using 5yr Data', code: 'undervaluedVsOvervaluedStatusYear5Id132'},
    {name: 'R11b - Under/Over Valued Using 10yr Data', code: 'undervaluedVsOvervaluedStatusYear10Id133'},
    {name: 'R11b - Under/Over Valued Using 15yr Data', code: 'undervaluedVsOvervaluedStatusYear15Id134'},
    {name: 'R11b - Under/Over Valued Using 20yr Data', code: 'undervaluedVsOvervaluedStatusYear20Id135'},
    {name: 'Website', code: 'websiteId136'},
]
